import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { handleConvert } from '../Conversion/Base64';
import { copyToClipboard } from '../Helpers/CommonHelpers';
import RandomContent from '../Components/RandomContent';
import { GetPageContentBySlug } from '../services/apiservice';
import { useLocation } from "react-router-dom";

const ImageToBase64 = () => {
  const [base64Image, setBase64Image] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [isConverting, setIsConverting] = useState(false);
  const [error, setError] = useState('');
  const [pageContent, setpageContent] = useState('');

  const location = useLocation();
  const paramlink = location.pathname.split("/").filter(Boolean).pop();

  useEffect(() => {
    GetPageContent();
  }, []);

  const GetPageContent = async () => {
    if (paramlink !== undefined && paramlink !== "") {
      try {
        const postMetaList = await GetPageContentBySlug(paramlink);
        const jsonMetaList = JSON.parse(postMetaList);
        setpageContent(jsonMetaList);
      } catch (error) {
        console.error('Error fetching the meta data:', error);
      }
    }
  };

  const validateImageFile = (file) => {
    if (file && file.type.startsWith('image/')) {
      setError('');
      setSelectedFile(file);
    } else {
      setError('Only image files are allowed.');
      setSelectedFile(null);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    validateImageFile(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    validateImageFile(file);
  };

  const handleConvertWrapper = () => {
    if (!selectedFile) {
      setError('Please select a valid image file.');
      return;
    }
    handleConvert(selectedFile, setBase64Image, setIsConverting);
  };

  const handleCopyWrapper = () => copyToClipboard(base64Image);

  return (
    <>
      <Header />

      <RandomContent />

      <div className="blog-area pb-20" >
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-12 col-md-12">
              <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                <div className="details">
                  <h4><a href="#">{pageContent?.section1header}</a></h4>

                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        pageContent?.section1text &&
                          pageContent.section1text.trim() !== ""
                          ? pageContent.section1text
                          : `Easily convert your images into Base64 code with Data Beautifier's Free Image to Base64 Conversion Online Tool.
                    Our Best Image to Base64 Conversion Online Tool is fast, accurate, and designed to handle all image types.
                    With the Simple Image to Base64 Converter Tool, anyone can encode images into Base64 format without requiring technical expertise.
                    The Easy Image to Base64 Converter Tool ensures a seamless experience—just upload your image and get the encoded result instantly.
                    Whether you're a developer or a designer, our tool saves time and simplifies your workflow.
                    Try Data Beautifier today for free and efficient conversions!`,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center" style={{ gap: '20px', marginTop: '30px' }}>

            {/* Upload Section */}
            <div className="full-col col-lg-5 col-md-5">
              <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                <div
                  onDrop={handleDrop}
                  onDragOver={(e) => e.preventDefault()}
                  style={{
                    border: '2px dashed #E64D25',
                    borderRadius: '8px',
                    padding: '30px',
                    textAlign: 'center',
                    backgroundColor: '#fff',
                    cursor: 'pointer',
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    id="fileUpload"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                  />
                  <label
                    htmlFor="fileUpload"
                    style={{
                      display: 'inline-block',
                      padding: '12px 25px',
                      backgroundColor: selectedFile ? '#E64D25' : '#E64D25',
                      color: '#fff',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                    }}
                  >
                    {selectedFile ? selectedFile.name : 'Choose Image or Drag Here'}
                  </label>
                </div>

                {error && (
                  <div
                    style={{ color: 'red', marginTop: '10px', fontWeight: 'bold' }}
                  >
                    {error}
                  </div>
                )}

                <button
                  onClick={handleConvertWrapper}
                  disabled={!selectedFile || isConverting}
                  className="default-btn icon four"
                  style={{
                    marginTop: '30px',
                    width: '100%',
                    backgroundColor: '#E64D25',
                    borderColor: '#E64D25',
                    cursor: !selectedFile || isConverting ? 'not-allowed' : 'pointer',
                  }}
                >
                  <i className="ri-exchange-line"></i>
                  Convert to Base64
                </button>
              </div>
            </div>

            {/* Output Section */}
            <div className="full-col col-lg-5 col-md-5">
              <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="1200">
                <textarea
                  rows={20}
                  value={base64Image}
                  readOnly
                  placeholder="Base64 URL will appear here..."
                  style={{
                    width: '100%',
                    padding: '15px',
                    borderRadius: '10px',
                    border: '1px solid #ccc',
                    fontSize: '14px',
                    fontFamily: 'monospace',
                    resize: 'vertical',
                  }}
                />
                <button
                  onClick={handleCopyWrapper}
                  className="default-btn icon four"
                  style={{
                    marginTop: '15px',
                    backgroundColor: '#E64D25',
                    borderColor: '#E64D25',
                    width: '100%',
                  }}
                >
                  <i className="ri-file-copy-line"></i>
                  Copy
                </button>
              </div>
            </div>

          </div>
        </div>

        {/* Section 2 Below Boxes */}
        {pageContent?.section2text &&
          pageContent.section2text.trim() !== "" && (
            <div className="blog-area">
              <div className="container-block-fluid">
                <div className="row justify-content-center">
                  <div className="full-col col-lg-12 col-md-12">
                    <div
                      className="single-blog-inner"
                      data-aos="fade-up"
                      data-aos-duration="2800"
                    >
                      <div className="details">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: pageContent.section2text,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        {/* Section 3 Below Boxes */}
        {pageContent?.section3text &&
          pageContent.section3text.trim() !== "" && (
            <div className="blog-area">
              <div className="container-block-fluid">
                <div className="row justify-content-center">
                  <div className="full-col col-lg-12 col-md-12">
                    <div
                      className="single-blog-inner"
                      data-aos="fade-up"
                      data-aos-duration="2800"
                    >
                      <div className="details">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: pageContent.section3text,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

      </div>

      <Footer />
    </>
  );
};

export default ImageToBase64;
